export const DISTRICT_ADMIN_ROLES = new Set(["district_president", "district_secretary", "district_treasurer"]);
export const ADMIN_ROLES = new Set([
  "admin", "state_president", "state_secretary", "state_treasurer",
  "district_president", "district_secretary", "district_treasurer",
]);
export const CONTENT_ROLES = new Set(["admin", "state_president", "state_secretary", "district_president", "district_secretary"]);
export const FINANCE_ROLES = new Set(["admin", "state_president", "state_treasurer", "district_president", "district_treasurer"]);
export const SUPER_ADMIN_ROLES = new Set(["admin"]);

export const ROLE_LABELS = {
  admin: "Super Admin",
  state_president: "State President",
  state_secretary: "State Secretary",
  state_treasurer: "State Treasurer",
  district_president: "District President",
  district_secretary: "District Secretary",
  district_treasurer: "District Treasurer",
  member: "Member",
};

export const isAdminRole = (r) => ADMIN_ROLES.has(r);
export const canManageContent = (r) => CONTENT_ROLES.has(r);
export const canManageFinance = (r) => FINANCE_ROLES.has(r);
export const isSuperAdmin = (r) => SUPER_ADMIN_ROLES.has(r);
export const isDistrictAdmin = (r) => DISTRICT_ADMIN_ROLES.has(r);
